document.addEventListener("DOMContentLoaded", function() {
    /** GiftShip Cart Drawer */
    setTimeout(() => {
        var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            const __buttonsWrapper = document.querySelector('.gs__drawer-footer-btns');
            const __checkoutButton = document.querySelector('.gs__drawer button.gs__drawer-checkout-btn');
            const __cartContents = data;
            const __cartItems = __cartContents.items;
            for(var x in __cartItems) {
                let __item = __cartItems[x];
                if((__item.properties._gs_a != '' && __item.properties._gs_a != null) && (__item.properties.Address != '' && __item.properties.Address != null)) {
                    if(__checkoutButton) {
                        __checkoutButton.classList.add('hidden');
                        const __newCheckoutButton = document.createElement("a");
                        __newCheckoutButton.href = '/a/gs/cart/confirm/?';
                        __newCheckoutButton.innerHTML = 'Checkout';
                        __newCheckoutButton.classList.add('button', 'button--primary', 'button--full-width', 'gs__drawer-new-checkout-btn');
                        __buttonsWrapper.insertBefore( __newCheckoutButton, __buttonsWrapper.firstChild);
                    }
                    break;
                } else {
                    /*console.error('Does not fulfill the condition.');*/
                }
            }
        });
    }, 2500);
});